import { createReducer, on } from '@ngrx/store';

import { setPaginationData } from './pagination.actions';
import type { PaginationState } from './pagination.state';
import { INITIAL_PAGINATION_STATE } from './pagination.state';

export const paginationReducer = createReducer(
  INITIAL_PAGINATION_STATE,
  on(
    setPaginationData,
    (state, { pageNumber, pageSize }): PaginationState => ({
      ...state,
      pageNumber: pageNumber,
      pageSize: pageSize,
    })
  )
);
